'use client';
import { format } from 'date-fns';

// https://date-fns.org/v2.29.1/docs/format
var DateFormat;
(function (DateFormat) {
    /** 2023-03-08 formatted as "8" */
    DateFormat["SHORT_DAY"] = "d";
    /** 2023-03-08 formatted as "08" */
    DateFormat["LONG_DAY"] = "dd";
    /** 2023-03-08 formatted as "Mar" */
    DateFormat["SHORT_MONTH"] = "MMM";
    /** 2023-03-08 formatted as "March" */
    DateFormat["LONG_MONTH"] = "MMMM";
    /** 2023-03-08 formatted as "Mar 8" */
    DateFormat["SHORT_MONTH_DAY"] = "MMM d";
    /** 2023-03-08 formatted as "March 8" */
    DateFormat["LONG_MONTH_DAY"] = "MMMM d";
    /** 2023-03-08 formatted as "Wed" */
    DateFormat["SHORT_DAY_OF_WEEK"] = "EEE";
    /** 2023-03-08 formatted as "Wednesday" */
    DateFormat["LONG_DAY_OF_WEEK"] = "EEEE";
    /** 2023-03-08 formatted as "Mar 8, 2023" */
    DateFormat["STANDARD"] = "MMM d, yyyy";
    /** 2023-03-08 formatted as "March 8, 2023" */
    DateFormat["LONG_STANDARD"] = "MMMM d, yyyy";
    /** 2023-03-08 formatted as "Mar 2023" */
    DateFormat["SHORT_MONTH_YEAR"] = "MMM yyyy";
    /** 2023-03-08 formatted as "March 2023" */
    DateFormat["LONG_MONTH_YEAR"] = "MMMM yyyy";
    /** 2023-03-08 formatted as "Wed, Mar 8" */
    DateFormat["SHORT_DAY_OF_WEEK_MONTH_DAY"] = "EEE, MMM d";
    /** 2023-03-08 formatted as "Wednesday, March 8" */
    DateFormat["LONG_DAY_OF_WEEK_MONTH_DAY"] = "EEEE, MMMM d";
    /** 2023-03-08 formatted as "3/8/2023" */
    DateFormat["NUMBER_STANDARD"] = "M/d/yyyy";
    /** 2023-03-08 formatted as "2023-03-08" */
    DateFormat["NUMBER_ISO"] = "yyyy-MM-dd";
})(DateFormat || (DateFormat = {}));
/**
 * Format a date
 * @param date - The date to format
 * @param dateFormat - The format to use [default: DateFormat.STANDARD
 * @returns The formatted date
 */
const formatDate = (date, dateFormat = DateFormat.STANDARD) => format(date, dateFormat);

export { DateFormat, formatDate };
//# sourceMappingURL=format-date.js.map
